module.exports = __webpack_public_path__ + "img/antimask_e.f526cf9b.jpg";